import { AbstractModel } from './AbstractModel'

export class Secret extends AbstractModel {
  public url: string|null = null
  public password: string|null = null
  public secret: string|null = null
  public expire: string|number|null = ''
}
